// extracted by mini-css-extract-plugin
export default {"header":"TaskInfoHeader_header__obUpm","buttonWrapper":"TaskInfoHeader_buttonWrapper__7zL13","button":"TaskInfoHeader_button__XODTN"};